import React, { useCallback, useState } from 'react';
import { Container, Box, Snackbar, Typography } from '@mui/material';
import { getMaexchenCollectProductsStructure } from '../csvImport';
import { updateMaexchenCollectProducts } from '../firebaseConnection/database';
import Dropzone from '../hooks/Dropzone';

const MaexchenArticlesImportPage = (): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  const onDrop = useCallback(async (acceptedFiles: File[]) => {
    if (acceptedFiles[0]) {
      try {
        const firebaseData = await getMaexchenCollectProductsStructure(
          acceptedFiles[0],
        );

        await updateMaexchenCollectProducts(firebaseData);

        setMessage('Success!');
        setOpen(true);
      } catch (e) {
        setMessage(`Error: ${e}`);
        setOpen(true);
      }
      setOpen(true);
    }
  }, []);

  return (
    <>
      <Container sx={{ width: `calc(100% - ${240}px)`, ml: `${240}px` }}>
        <Box
          component="main"
          sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
        >
          <Typography variant="h4">Mäxchen Artikel </Typography>

          <Dropzone drop={csvFile => onDrop(csvFile)} />
        </Box>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={() => setOpen(false)}
          message={message}
        />
      </Container>
    </>
  );
};

export default MaexchenArticlesImportPage;
